import React from 'react';

export default function LiveScores(props) {
    const score = props.data;
    const totalScore = score.formattedScores.find(sc => sc.isTotalScore);

    return (
        <div className="xs_liveScores ml-auto flex shrink-0">
            <div className="flex flex-col h-fit items-end">
                <span className="text-xxs text-cs9">{score.periodo} {score.currentMinute ? `(${score.currentMinute})` : ''}</span>
                <div className="flex">
                    {score.formattedScores.slice(1).map(score =>
                        <div key={score.p} className="ml-1 flex flex-col items-center h-fit">
                            <span className="text-xxs">{score.p}</span>
                            <span className="text-xxs">{`${score.s1}-${score.s2}`}</span> 
                        </div>
                    )}
                </div>
            </div>
            {totalScore &&
                <div className="grid grid-rows-2 ml-1 px-1 bg-cs4 text-cs1 rounded-sm">
                    <span className="justify-self-center text-sm">{totalScore.s1}</span>
                    <span className="justify-self-center text-sm">{totalScore.s2}</span>
                </div>
            }
        </div>
    );
}
